module.exports = __webpack_public_path__ + "static/master-fe5bbe2526755f475f9f5ad108c061a9.png";